import moment from 'moment';
import * as Common from "../../commons/common";

export class SearchCondition {
  submitted_at_from: string = ""
  submitted_at_to: string = ""
  updated_at_from: string = ""
  updated_at_to: string = ""
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  subject_code: string = null
  student_code: string = ""
  sheet_code: string = ""
  status: number = 3
  sheet_type: number = Common.SheetTypeEnum.Report
  is_downloaded: number = null
}

export class Examinee {
  course_code: string
  course_name: string
  campus_code: string
  campus_name: string
  class_code: string
  class_name: string
  student_code: string
  student_name: string
  grade: string
  kumi: string
  student_no: number
  curriculum_code: string
  curriculum_name: string
  subject_code: string
  subject_name: string
  sheet_code: string
  sheet_name: string
  times: number
  score: number
  view_point1_score: number
  view_point2_score: number
  view_point3_score: number
  submitted_at: string
  examinee_id: number
  publish_at: string
  std_deadline_at: string
  final_deadline_at: string
  last_scored_at: string

  constructor(x: any){
    this.course_code = x.course_code
    this.course_name = x.course_name
    this.campus_code = x.campus_code
    this.campus_name = x.campus_name
    this.class_code = x.class_code
    this.class_name = x.class_name
    this.student_code = x.student_code
    this.student_name = x.student_name
    this.grade = Common.GetGradeNameByGrade(x.grade)
    this.kumi = x.kumi
    this.student_no = x.student_no
    this.curriculum_code = x.curriculum_code
    this.curriculum_name = x.curriculum_name
    this.subject_code = x.subject_code
    this.subject_name = x.subject_name
    this.sheet_code = x.sheet_code
    this.sheet_name = x.sheet_name
    this.times = x.times
    this.score = x.score;
    this.view_point1_score = x.view_point1_score;
    this.view_point2_score = x.view_point2_score;
    this.view_point3_score = x.view_point3_score;
    this.submitted_at = x.submitted_at ? moment(x.submitted_at).format("Y/MM/DD HH:mm") : null;
    this.examinee_id = x.examinee_id;
    this.publish_at = x.publish_at ? moment(x.publish_at).format("Y/MM/DD HH:mm") : null;
    this.std_deadline_at = x.std_deadline_at ? moment(x.std_deadline_at).format("Y/MM/DD HH:mm") : null;
    this.final_deadline_at = x.final_deadline_at ? moment(x.final_deadline_at).format("Y/MM/DD HH:mm") : null;
    this.last_scored_at = x.last_scored_at ? moment(x.last_scored_at).format("Y/MM/DD HH:mm") : null;
  }
}